/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Tag3d1Inputs */

const zh_showcase_tag3d1 = /** @type {(inputs: Showcase_Tag3d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D展示`)
};

const en_showcase_tag3d1 = /** @type {(inputs: Showcase_Tag3d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Display`)
};

const es_showcase_tag3d1 = /** @type {(inputs: Showcase_Tag3d1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exhibición 3D`)
};

/**
* | output |
* | --- |
* | "3D Display" |
*
* @param {Showcase_Tag3d1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_tag3d1 = /** @type {((inputs?: Showcase_Tag3d1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Tag3d1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_tag3d1(inputs)
	if (locale === "en") return en_showcase_tag3d1(inputs)
	return es_showcase_tag3d1(inputs)
});
export { showcase_tag3d1 as "showcase_tag3D" }